import { SharedserviceMelcoModelsReferences } from "melco-shared-logic";
import { Button, EditIcon, Table, ValueOrFallback } from "melco-ui";
import { useTranslation } from "react-i18next";
import { ReferencesListTitle } from "./ReferencesListTitle";

export type DataMappingReferencesListProps = {
  dataMappingList?: SharedserviceMelcoModelsReferences[];
};

export const DataMappingReferencesList: React.FC<
  DataMappingReferencesListProps
> = ({ dataMappingList }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("global.references.data_mappings.list.columns.name"),
      key: "name",
      dataIndex: "name",
      render: (_: string, item: SharedserviceMelcoModelsReferences) => (
        <ValueOrFallback
          value={item.name}
          fallback={t("global.fallback.empty")}
        />
      ),
    },
    {
      align: "right" as const,
      render: (_: string, item: SharedserviceMelcoModelsReferences) => (
        <Button
          icon={<EditIcon />}
          size="small"
          href={["/input-formats", item.parent_id, "data-mappings"].join("/")}
          target="_blank"
        >
          {t("global.references.actions.edit.button")}
        </Button>
      ),
    },
  ];

  return (
    <>
      <ReferencesListTitle level={5}>
        {t("global.references.data_mappings.title")}
      </ReferencesListTitle>

      <Table
        showSorterTooltip={false}
        dataSource={dataMappingList}
        columns={columns}
        rowKey="id"
        pagination={false}
        noDataMessage={t("global.references.data_mappings.list.empty")}
      />
    </>
  );
};
